function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, Array, JSON, Object, String, searchText) {
    var h = require("panel").h;
    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("div", {
        "class": {
          'filter-bar': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(($attr(`selected-count`) > 0) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "on": {
              click: $helpers.handleClearSelected
            },
            "class": {
              'selected-count': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'results': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("" + ($attr(`selected-count`)) + " Selected");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'x-button-wrap': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                "attrs": {
                  icon: `x`
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'action-section': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((function() {
              var $$obj = ($attr(`actions`));
              var $$eachNodes;
              var $$iterated = false;
              if (Array.isArray($$obj)) {
                $$eachNodes = $$obj.reduce(function($$eachNodes, actionOption, $index) {
                  $$iterated = true;
                  return $$eachNodes.concat((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "attrs": {
                        role: "button",
                        "aria-disabled": actionOption.disabled ? "true" : undefined
                      },
                      "on": {
                        click: actionOption.disabled ? null : () => $helpers.handleClickAction(actionOption.eventName),
                      },
                      "class": Object.assign({}, {
                        disabled: actionOption.disabled,
                      }, {
                        'action': true
                      }),
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'icon': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                          "attrs": {
                            icon: actionOption.icon
                          },
                        }));;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'label': true
                        },
                      }, [__vjadeSafeCode(actionOption.label)]));
                      __jade_nodes = __jade_nodes.concat((actionOption.disabledTooltip && actionOption.disabled) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                          "attrs": {
                            placement: `bottom`,
                            'max-width': `150px`
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat("" + (actionOption.disabledTooltip) + "");;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this)) : (actionOption.tooltip) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                          "attrs": {
                            placement: `bottom`,
                            'max-width': `150px`
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat("" + (actionOption.tooltip) + "");;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this)) : undefined);;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this));
                }, []);
              } else {
                $$eachNodes = [];
                for (var $$objKey in $$obj) {
                  (function() {
                    var $index = $$objKey;
                    if ($$obj.hasOwnProperty($index)) {
                      $$iterated = true;
                      var actionOption = $$obj[$index];
                      $$eachNodes = $$eachNodes.concat((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "attrs": {
                            role: "button",
                            "aria-disabled": actionOption.disabled ? "true" : undefined
                          },
                          "on": {
                            click: actionOption.disabled ? null : () => $helpers.handleClickAction(actionOption.eventName),
                          },
                          "class": Object.assign({}, {
                            disabled: actionOption.disabled,
                          }, {
                            'action': true
                          }),
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'icon': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                              "attrs": {
                                icon: actionOption.icon
                              },
                            }));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'label': true
                            },
                          }, [__vjadeSafeCode(actionOption.label)]));
                          __jade_nodes = __jade_nodes.concat((actionOption.disabledTooltip && actionOption.disabled) ? ((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                              "attrs": {
                                placement: `bottom`,
                                'max-width': `150px`
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat("" + (actionOption.disabledTooltip) + "");;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this)) : (actionOption.tooltip) ? ((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                              "attrs": {
                                placement: `bottom`,
                                'max-width': `150px`
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat("" + (actionOption.tooltip) + "");;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this)) : undefined);;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this));
                    }
                  })();
                }
              }

              return $$eachNodes;
            })());;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'filtered-count': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'results': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("" + ($attr(`result-count`)) + "");;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'filter-by-section': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": Object.assign({}, {
                hidden: $helpers.isFilterSectionHidden()
              }, {
                'filter-by-text': true
              }),
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Filter by");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat((function() {
              var $$obj = ($attr(`filters`));
              var $$eachNodes;
              var $$iterated = false;
              if (Array.isArray($$obj)) {
                $$eachNodes = $$obj.reduce(function($$eachNodes, filterOption, $index) {
                  $$iterated = true;
                  return $$eachNodes.concat((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat((filterOption.options.length >= 1) ? ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("mp-select", {
                        "attrs": {
                          options: JSON.stringify($helpers.getLabelList(filterOption)),
                          'menu-height': 300,
                          'menu-width': 200,
                          'selected-option': $helpers.getSelectedLabel(filterOption),
                        },
                        "on": {
                          change: ev => $helpers.handleFilterChange(ev, filterOption.name)
                        },
                        "class": {
                          [`filter-${filterOption.name}`]: true
                        },
                      }));;
                      return __jade_nodes
                    }).call(this)) : undefined);;
                    return __jade_nodes
                  }).call(this));
                }, []);
              } else {
                $$eachNodes = [];
                for (var $$objKey in $$obj) {
                  (function() {
                    var $index = $$objKey;
                    if ($$obj.hasOwnProperty($index)) {
                      $$iterated = true;
                      var filterOption = $$obj[$index];
                      $$eachNodes = $$eachNodes.concat((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat((filterOption.options.length >= 1) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("mp-select", {
                            "attrs": {
                              options: JSON.stringify($helpers.getLabelList(filterOption)),
                              'menu-height': 300,
                              'menu-width': 200,
                              'selected-option': $helpers.getSelectedLabel(filterOption),
                            },
                            "on": {
                              change: ev => $helpers.handleFilterChange(ev, filterOption.name)
                            },
                            "class": {
                              [`filter-${filterOption.name}`]: true
                            },
                          }));;
                          return __jade_nodes
                        }).call(this)) : undefined);;
                        return __jade_nodes
                      }).call(this));
                    }
                  })();
                }
              }

              return $$eachNodes;
            })());
            __jade_nodes = __jade_nodes.concat(($helpers.isFilterSelected()) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "on": {
                  click: $helpers.handleFilterReset
                },
                "class": {
                  'reset-filter-button': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("reset filter");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat(h("mp-icon-input", {
              "attrs": {
                icon: `search`,
                placeholder: $attr(`search-placeholder`),
                value: searchText,
              },
              "props": {
                maxLength: 50,
                value: searchText,
              },
              "on": {
                input: $helpers.handleUpdateInput,
              },
              "class": {
                'search-input': true
              },
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "searchText" in locals ? locals.searchText : typeof searchText !== "undefined" ? searchText : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;